import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { LeagueItem, RaceDaysTableItem, RacesService, Race } from '../service/races.service';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-leageTable',
    standalone: true,
    templateUrl: './leagueTable.component.html',
    imports: [
        CommonModule,
        TableModule,
        RouterModule
    ],
    providers: [
        RacesService
    ]
})
export class LeagueTable implements OnInit{
    constructor(private racesService: RacesService,private changeDetectorRef: ChangeDetectorRef) {}

    @Input() season: number = 0
    @Input() group: number = 0;

    playerList: LeagueItem[] = [];
    playerListLoading = true;

    raceDays: RaceDaysTableItem[] = [];
    raceDaysLoading = true;

    isKeyDriver(status: string): boolean {
        return status === "S";
    }
    /*
    ngOnInit() {
        this.racesService.getRaceDays(String(this.season), String(this.group)).subscribe((days) => {
            this.raceDays = days;
            this.raceDaysLoading = false;
            this.changeDetectorRef.detectChanges(); // Trigger change detection
            console.log(this.raceDays);
        });

        this.racesService.getLeagueTableForSeason(String(this.season), String(this.group)).subscribe((player) => {
            this.playerList = player;
            this.sortPlayerList();
            this.playerListLoading = false;
            this.changeDetectorRef.detectChanges(); // Trigger change detection
            console.log(this.playerList);
        });


    }*/
    ngOnInit() {
        this.loadData();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['season'] || changes['group']) {
            this.loadData();
        }
    }

    loadData() {
        this.playerListLoading = true;
        this.racesService.getLeagueTableForSeason(String(this.season), String(this.group)).subscribe((player) => {
            this.playerList = player;
            this.sortPlayerList();
            this.playerListLoading = false;
            this.changeDetectorRef.detectChanges(); // Trigger change detection
            console.log("leagueTable - getLeagueTableForSeason");
            console.log(this.playerList);
        });

        this.racesService.getRaceDays(String(this.season), String(this.group)).subscribe((days) => {
            this.raceDays = days;
            this.raceDaysLoading = false;
            this.changeDetectorRef.detectChanges(); // Trigger change detection
            console.log("leagueTable - getRaceDays");
            console.log(this.raceDays);
        });
    }

    sortPlayerList() {
        this.playerList.sort((a, b) => {
            // Example: Sort by position_finished in ascending order
            return (a.final_position ?? 0) - (b.final_position ?? 0);
        });
    }

    hasDayRacePoints(player_id: number, raceday: string): boolean{
        const player = this.playerList.find(p => p.player_id === player_id);
        if (player && player.races) {
            return player.races.some(race => race.day_id === raceday);
        }
        return false;
    }


    getDayRacePoints(player_id: number, raceday: string){
        const player = this.playerList.find(p => p.player_id === player_id);
        if (player && player.races) {
            const race = player.races.find(race => race.day_id === raceday);
            return race ? race.points_v1 : null;
        }
        return null;
    }
}
